import { Component, type ErrorInfo, type ReactNode } from "react"
import ErrorPage from "./ErrorPage"


interface Props {
  children?: ReactNode
  onReset?: () => void
}

interface State {
  hasError: boolean
  error?: Error
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo)
  }

  private handleRetry = () => {
    this.setState({ hasError: false })
    if (this.props.onReset) {
      this.props.onReset()
    }
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPage onRetry={this.handleRetry} />
    }

    return this.props.children
  }
}

export default ErrorBoundary

